import { useState, useEffect } from 'react';
import { Consumer, Subscription } from '@rails/actioncable';

export type Jackpot = {
  name: string;
  current_value: number;
};

export type Campaign = {
  url: string | null;
  currency: string;
  jackpots: Jackpot[];
};

const useCampaigns = (initialValues: Campaign[]): Campaign[] => {
  const [campaigns, setCampaigns] = useState<Campaign[]>(initialValues);

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription: Subscription = cable.subscriptions.create(
      {
        channel: 'JackpotAggregator::CampaignsChannel',
      },
      {
        received: (v) => setCampaigns(v.data),
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return campaigns;
};

export default useCampaigns;
